import { createContext } from 'react'

import { UrlStateContextValue } from './UrlStateContext.types'

export const UrlStateContext = createContext<UrlStateContextValue | undefined>(undefined)
